// extracted by mini-css-extract-plugin
export default {"button":"buttonKYT_button__YO7oJ"};